import { Facebook, Instagram, LinkedIn, Twitter } from '../../assets/svg';

export const icons = [
  {
    img: Facebook,
    path: 'https://www.facebook.com/AbbeyBankPlc'
  },
  {
    img: Instagram,
    path: 'https://www.instagram.com/abbeybankplc/'
  },
  {
    img: Twitter,
    path: 'https://twitter.com/Abbeybankplc'
  },
  {
    img: LinkedIn,
    path: 'https://www.linkedin.com/company/abbeybankplc/mycompany/'
  },
];
